import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/display-name */
import React from "react";
import { defaultSortPropertiesOverride } from "../constants";
import { ColumnType } from "../DataGridTypes";

var renderNumericCell = function renderNumericCell(cell) {
  var formattedNumber = cell.value.toLocaleString();
  return /*#__PURE__*/React.createElement(React.Fragment, null, formattedNumber);
};

export var getRenderer = function getRenderer() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ColumnType.TEXT;

  if (type === ColumnType.NUMERIC) {
    return renderNumericCell;
  }

  return "Cell";
};
export var getCustomHeaderRenderer = function getCustomHeaderRenderer(renderHeader, isSortingConfigured, sortingAriaLabel) {
  return function (_ref) {
    var column = _ref.column;
    var id = column.id,
        isSortedDesc = column.isSortedDesc,
        isSorted = column.isSorted,
        getHeaderProps = column.getHeaderProps,
        getSortByToggleProps = column.getSortByToggleProps;
    var isSortingEnabled = getHeaderProps && getSortByToggleProps && isSortingConfigured;
    var columnRenderProps = {
      id: id
    };

    if (isSortingEnabled) {
      var toggleProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, column.getHeaderProps()), column.getSortByToggleProps()), defaultSortPropertiesOverride), {}, {
        ariaLabel: sortingAriaLabel
      });

      columnRenderProps.sortProps = {
        isSortedDesc: isSortedDesc,
        isSorted: isSorted,
        toggleProps: toggleProps
      };
    }

    return renderHeader(columnRenderProps);
  };
};